import { render, staticRenderFns } from "./SitesTable.vue?vue&type=template&id=baff8c0c&scoped=true"
import script from "./SitesTable.vue?vue&type=script&lang=js"
export * from "./SitesTable.vue?vue&type=script&lang=js"
import style0 from "./SitesTable.vue?vue&type=style&index=0&id=baff8c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff8c0c",
  null
  
)

export default component.exports